import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import * as echarts from "echarts";
import { onlineUserCount, newRoleCount } from "@/api/data";
import serverList from "../../../components/serverList/serverOptions.vue";
export default {
  components: {
    serverList: serverList
  },
  props: {
    api: String,
    title: String
  },
  data: function data() {
    return {
      //获取当前日期
      onLineNowDate: "",
      onLineArrTimeTitle: [],
      //当前时间的数组
      onLineArrTime: [],
      //前一天时间的数组
      befOnLineArrTime: [],
      //当前数量的数组
      onLineArrNum: [],
      //前一天数量的数组
      befonLineArrNum: [],
      currentValue: "",
      onLineTimeNow: [],
      onLineTimeBefore: [],
      searchInfo: {
        server_id: []
      },
      startValue: "",
      endValue: "",
      value: "按照分钟查看",
      grouping: "minute",
      timeTitle: "按照分钟查看"
    };
  },
  watch: {
    value: function value(newVal) {
      this.timeTitle = newVal;
    }
  },
  methods: {
    checkBtn: function checkBtn() {
      if (this.timeTitle) {
        if (this.timeTitle == "按照分钟查看") {
          this.timeType = 2;
        } else {
          this.timeType = 1;
        }
      } else {
        this.$message({
          message: "请选择查询类别",
          type: "warning"
        });
        return;
      }
      this.getDateTime();
    },
    getData: function getData(sdate, edate) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result, _result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.api == "newRoleCount")) {
                _context.next = 7;
                break;
              }
              _context.next = 3;
              return newRoleCount({
                sdate: sdate,
                edate: edate,
                grouping: _this.grouping,
                server_id: _this.searchInfo.server_id
              });
            case 3:
              result = _context.sent;
              return _context.abrupt("return", result);
            case 7:
              _context.next = 9;
              return onlineUserCount({
                sdate: sdate,
                edate: edate,
                grouping: _this.grouping,
                server_id: _this.searchInfo.server_id
              });
            case 9:
              _result = _context.sent;
              return _context.abrupt("return", _result);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getDateTime: function getDateTime() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var date, y, m, h, startValue, endValue, d, onLineBefDate, onLineTimeStade, onLineTimeEdate, befOnLineStade, befOnLineEdate, i, j;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.onLineArrTimeTitle = [];
              _this2.onLineArrTime = [];
              _this2.befOnLineArrTime = [];
              _this2.onLineArrNum = [];
              _this2.befonLineArrNum = [];
              _this2.onLineTimeNow = [];
              _this2.onLineTimeBefore = [];

              //处理当前日期为标准时间
              date = new Date();
              y = date.getFullYear();
              m = date.getMonth() + 1;
              h = date.getHours(); // h = h < 10 ? "0" + h : h;
              startValue = h - 1;
              endValue = h + 1;
              _this2.startValue = (startValue < 0 ? "0" + startValue : startValue) + ":00";
              _this2.endValue = (endValue < 0 ? "0" + endValue : endValue) + ":00";
              m = m < 10 ? "0" + m : m;
              d = date.getDate();
              d = d < 10 ? "0" + d : d;

              //当前选中的标准日期
              _this2.onLineNowDate = y + "-" + m + "-" + d;
              //前一天的标准日期
              onLineBefDate = _this2.getNextDate(_this2.onLineNowDate, -1, 1, 1); //当前选中的时间
              onLineTimeStade = y + "-" + m + "-" + d;
              onLineTimeEdate = y + "-" + m + "-" + d; //当前选中的前一天
              befOnLineStade = _this2.getNextDate(onLineTimeStade, -1, 1);
              _this2.currentValue = befOnLineStade + ":" + "00" + ":" + "00" + ":" + "00";
              befOnLineEdate = _this2.getNextDate(onLineTimeEdate, -1, 2); //获取当前和前一天的日期标题
              _this2.onLineArrTimeTitle.push(onLineBefDate, _this2.onLineNowDate);
              _context2.next = 28;
              return _this2.getData(onLineTimeStade, onLineTimeEdate);
            case 28:
              _this2.onLineTimeNow = _context2.sent;
              _context2.next = 31;
              return _this2.getData(befOnLineStade, befOnLineEdate);
            case 31:
              _this2.onLineTimeBefore = _context2.sent;
              for (i = 0; i < _this2.onLineTimeNow.data.length; i++) {
                _this2.onLineArrTime.push(_this2.onLineTimeNow.data[i].time);
                _this2.onLineArrNum.push(_this2.onLineTimeNow.data[i].num);
              }
              for (j = 0; j < _this2.onLineTimeBefore.data.length; j++) {
                _this2.befOnLineArrTime.push(_this2.onLineTimeBefore.data[j].time);
                _this2.befonLineArrNum.push(_this2.onLineTimeBefore.data[j].num);
              }
              _this2.initCharts();
            case 35:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // date 代表指定的日期，格式：2018-09-27
    // day 传-1表始前一天，传1表始后一天
    //Stade时候传 === 1;Edate === 2
    //日期还是时间  dateTimeType
    getNextDate: function getNextDate(date, day) {
      var dd = new Date(date);
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    open2: function open2() {
      this.$notify({
        title: "充值排行",
        message: "(1)根据日期查询某天的实时在线人数和创角人数，并提供前一天的实时在线人数做对比，制作折线图。" + "(2)默认打开当天的实时在线人数。" + "(3)可选中一个或者多个服的数据，选择多个服时，直接数据累加。" + "(4)在线使用研发上报的5分钟在线数据。" + "(5)创角使用研发上报的创角日志进行10分钟的统计，按服进行统计。" + "(6)折线图可以选择只显示在线、创角或者两种都显示。",
        duration: 0
      });
    },
    initCharts: function initCharts() {
      var chartDom = this.$refs.main;
      var myChart = echarts.init(chartDom);
      this.option && myChart.setOption(this.option);

      // 绘制图表

      myChart.setOption({
        title: {
          text: this.title
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.onLineArrTimeTitle
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          name: "时间",
          data: this.befOnLineArrTime
        },
        yAxis: {
          type: "value",
          name: "人数"
        },
        dataZoom: [{
          type: "inside",
          show: true
        }, {
          type: "inside",
          show: true
        }],
        // dataZoom: [
        //     {
        //         bottom: 10,
        //         height: 25,
        //         type: "slider",
        //         show: true, //是否显示下滑块
        //         xAxisIndex: [0], //选择的x轴
        //         start: 20, //初始数据显示多少
        //         end: 50, //初始数据最多显示多少
        //     },
        // ],
        series: [{
          name: this.onLineArrTimeTitle[0],
          type: "line",
          data: this.befonLineArrNum
        }, {
          name: this.onLineArrTimeTitle[1],
          type: "line",
          data: this.onLineArrNum
        }]
      });
    }
  },
  mounted: function mounted() {
    this.getDateTime();
    var that = this;
    setTimeout(function () {
      that.initCharts();
    }, 2000);
  }
};